import { __assign } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import '../../constants/api.esm.js';
import MiniCartIcon from './MiniCartIcon.esm.js';
import styles from './MiniCart.module.esm.js';

var TooltipTrigger = function (_a) {
    var className = _a.className, getTriggerProps = _a.getTriggerProps, triggerRef = _a.triggerRef, triggerComponent = _a.triggerComponent, isMobile = _a.isMobile;
    var _b = React.useContext(CartContext), gotoCartPage = _b.gotoCartPage, shouldSkipGotoCartByClickingIcon = _b.shouldSkipGotoCartByClickingIcon;
    var handleKeyDown = function (e) {
        var isEnter = e.key === 'Enter';
        if (isEnter) {
            return gotoCartPage();
        }
    };
    return (React.createElement("div", __assign({}, getTriggerProps({
        className: classNames(styles.root, className),
        ref: triggerRef,
    }), { "aria-label": "Cart", "data-testid": "mini-cart-icon" }, (!shouldSkipGotoCartByClickingIcon && !isMobile && { onClick: gotoCartPage }), (!shouldSkipGotoCartByClickingIcon && !isMobile && { onKeyDown: function (e) { return handleKeyDown(e); } }), { role: "button", tabIndex: 0 }), triggerComponent || React.createElement(MiniCartIcon, null)));
};

export { TooltipTrigger as default };
//# sourceMappingURL=TooltipTrigger.esm.js.map
